import { FormControl, Grid, MenuItem, Select, Stack, TextField, Typography, useTheme } from "@mui/material";
import { AssCorrectionResult, AssessmentInstanceDto, AssessmentPlayerMode, AssessmentQuestionDto, QuestionType } from "generated/CoreApi_v1";
import React from "react";
import { useTranslation } from "react-i18next";
import { AssRevisionResultIcon } from "views/assessment/player/common/AssCommon";

interface IProps {
    viewData: AssessmentInstanceDto;
    question: AssessmentQuestionDto;
    onChange: (question: AssessmentQuestionDto) => void;
}

export const AssPlayerFillIn: React.FC<IProps> = ({ question, viewData, onChange }) => {

    const { t } = useTranslation("assessment");
    const theme = useTheme();

    ///
    const changeAnswerAlternative = (alternativeId: string, value: string) => {
        if (question) {
            var newAnswers = question.answers ? [...question.answers] : [];
            newAnswers = newAnswers.filter(x => x.alternativeId != alternativeId);
            newAnswers = [...newAnswers, {
                alternativeId: alternativeId,
                answer: value,
                numericAnswer: null
            }];
            onChange({ ...question, answers: newAnswers });
        }
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <Stack direction="column" spacing={2}>
            {
                question?.alternatives.map((v) => {
                    const answer = question.answers?.find(x => x.alternativeId == v.alternativeId)?.answer ?? "";
                    const result = question.revision?.alternatives.find(x => x.alternativeId == v.alternativeId);
                    const highlightColor = result && result.correctionResult == AssCorrectionResult.Correct
                        ? theme.palette.success.main
                        : result && result.correctionResult == AssCorrectionResult.Wrong
                            ? theme.palette.error.main
                            : undefined;
                    return (
                        <Stack key={v.alternativeId} direction="column">
                            <Typography variant="body1">
                                {v.text}
                            </Typography>
                            <Grid container alignItems="center" spacing={1}>
                                <Grid size="grow">
                                    <FormControl variant="outlined" fullWidth>
                                        {
                                            question.questionType == QuestionType.Dropdown && viewData.playerMode != AssessmentPlayerMode.UserReview && viewData.playerMode != AssessmentPlayerMode.FinalResult
                                                ?
                                                <Select
                                                    name="alternative"
                                                    value={answer}
                                                    variant="outlined"
                                                    size="small"
                                                    onChange={(e) => changeAnswerAlternative(v.alternativeId, e.target.value)}
                                                    inputProps={{
                                                        style: { width: 100, textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "pre" }
                                                    }}
                                                >
                                                    {
                                                        v.dropdownAnswers.map((answerOption, index) => (
                                                            <MenuItem key={index} value={answerOption}>
                                                                {answerOption}
                                                            </MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                                :
                                                <TextField
                                                    name="alternativefilltext"
                                                    value={answer}
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    autoComplete="off"
                                                    margin="dense"
                                                    slotProps={{
                                                        input: {
                                                            inputProps: { maxLength: 512 }
                                                        }
                                                    }}
                                                    disabled={viewData.playerMode == AssessmentPlayerMode.UserReview || viewData.playerMode == AssessmentPlayerMode.FinalResult}
                                                    sx={highlightColor
                                                        ?
                                                        {                                           // - The TextField-root
                                                            border: 'solid 2px #0ff',               // - For demonstration: set the TextField-root border
                                                            borderColor: highlightColor,
                                                            borderRadius: "6px",
                                                            input: {
                                                                "-webkit-text-fill-color": `${highlightColor} !important`,
                                                                color: `${highlightColor} !important`,
                                                            },
                                                            // (Note: space or no space after `&` matters. See SASS "parent selector".)
                                                            '& .MuiOutlinedInput-root': {           // - The Input-root, inside the TextField-root
                                                                '& fieldset': {                     // - The <fieldset> inside the Input-root
                                                                    borderColor: highlightColor,    // - Set the Input border
                                                                },
                                                                '&:hover fieldset': {
                                                                    borderColor: highlightColor,    // - Set the Input border when parent has :hover
                                                                },
                                                                '&.Mui-focused fieldset': {         // - Set the Input border when parent is focused
                                                                    borderColor: highlightColor,
                                                                },
                                                                '& input': {                        // - The <fieldset> inside the Input-root
                                                                    borderColor: highlightColor,    // - Set the Input border
                                                                },
                                                            },
                                                        }
                                                        :
                                                        {}
                                                    }
                                                    onChange={(e) => changeAnswerAlternative(v.alternativeId, e.target.value)}
                                                />
                                        }
                                    </FormControl>
                                </Grid>
                                <Grid size={{ xs: 0.7 }} textAlign="center">
                                    <AssRevisionResultIcon
                                        result={result?.correctionResult}
                                        correctAnswer={
                                            result?.correctAnswer
                                                ? `${t("AssPlayer.Question.CorrectText")}: ${result.correctAnswer}`
                                                : undefined
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Stack>
                    );
                })
            }
        </Stack>
    );
};
